import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './core/auth/login/login.component';
import { DashboardComponent } from './core/components/website/dashboard/dashboard.component';
import { ProfileComponent } from './core/components/website/MSME/profile/profile.component';
import { AuthService } from './shared/services/auth.service';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { SsoLandingComponent } from './core/auth/sso-landing/sso-landing.component';
import { SsoWebsiteurlComponent } from './core/auth/sso-websiteurl/sso-websiteurl.component';

const routes: Routes = [

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

  {
    path: 'login',
    component: LoginComponent
  },

  {
    path: 'sso-landing',
    component: SsoLandingComponent
  },

  {
    path: 'sso-websiteurl',
    component: SsoWebsiteurlComponent
  },

  //{
  //  path: 'dashboard',
  //  component: DashboardComponent,
  //  children:
  //    [
  //      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  //      {
  //        path: 'profile',
  //        component: ProfileComponent
  //      },
  //    ]
  //},

  {
    path: '',
    loadChildren: () => import('./core/components/website/website.module').then(w => w.WebsiteModule)
    /*,
    canActivate: [AuthService],
    data: { module: 'MSME' }
    //component: LoginComponent*/
  },
  //testing code for IA routing file
  /*{
    path: '',
    loadChildren: () => import('./core/components/website/IAwebsite.module').then(w => w.IAWebsiteModule),
    data: { module: 'IA' }
    //component: LoginComponent
  },*/
  //{
  //  path: 'cart',
  //  loadChildren: () => import('./core/components/website/website.module').then(w => w.WebsiteModule)
  //},
  //{
  //  path: 'product-detail',
  //  loadChildren: () => import('./core/components/website/website.module').then(w => w.WebsiteModule)
  //},
  {
    path: '',
    loadChildren: () => import('./core/components/admin/admin.module').then(w => w.AdminModule)

  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }]
})
export class AppRoutingModule { }



//import { NgModule } from '@angular/core';
//import { RouterModule, Routes } from '@angular/router';
//import { LoginComponent } from './core/auth/login/login.component';
//import { DashboardComponent } from './core/components/website/dashboard/dashboard.component';
//import { ProfileComponent } from './core/components/website/MSME/profile/profile.component';
//import { AuthService } from './shared/services/auth.service';
//import { HashLocationStrategy, LocationStrategy } from '@angular/common';

//const routes: Routes = [

//  {
//    path: '',
//    redirectTo: 'login',
//    pathMatch: 'full'
//  },

//  {
//    path: 'login',
//    component: LoginComponent,
//    children:
//      [{
//        path: '',
//        loadChildren: () => import('./core/components/website/website.module').then(w => w.WebsiteModule),
//       // canActivate: [AuthService]
//      },
//      {
//        path: '',
//        loadChildren: () => import('./core/components/admin/admin.module').then(w => w.AdminModule)

//      }

//      ]
//  },

//  //{
//  //  path: 'dashboard',
//  //  component: DashboardComponent,
//  //  children:
//  //    [
//  //      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
//  //      {
//  //        path: 'profile',
//  //        component: ProfileComponent
//  //      },
//  //    ]

//  //},

//  //{
//  //  path: '',
//  //  loadChildren: () => import('./core/components/website/website.module').then(w => w.WebsiteModule)

//  //},

//  //{
//  //  path: '',
//  //  loadChildren: () => import('./core/components/admin/admin.module').then(w => w.AdminModule)

//  //}
//];


//@NgModule({
//  imports: [RouterModule.forRoot(routes)],
//  exports: [RouterModule],
//  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }]
//})
//export class AppRoutingModule { }

